import { OgrafManager } from '../../engine/streamrapp/ograf/OgrafManager';
import { OgrafServiceOutput } from './OgrafServiceOutput';
export class OgrafService {
    static instance;
    output;
    manager;
    static getInstance() {
        if (!OgrafService.instance) {
            OgrafService.instance = new OgrafService();
        }
        return OgrafService.instance;
    }
    static getNotificationInterface() {
        return OgrafService.getInstance();
    }
    static getOutput() {
        return OgrafServiceOutput.getReactiveOutput();
    }
    constructor() {
        this.output = new OgrafServiceOutput();
        this.manager = OgrafManager.getInstance();
        this.manager.on('graphicAdded', (entry) => {
            this.output.addGraphic(entry);
        });
        this.manager.on('graphicRemoved', (id) => {
            this.output.removeGraphic(id);
        });
        this.manager.on('graphicStateChanged', (id, state, currentStep) => {
            this.output.updateGraphicState(id, state, currentStep);
        });
        this.manager.on('error', (_id, message) => {
            this.output.setError(message);
            console.error('[OgrafService]', message);
        });
    }
    async initialize() {
        await this.manager.initialize();
    }
    notifyAddOgrafGraphic(source) {
        void this.manager.addGraphic(source);
    }
    notifyRemoveOgrafGraphic(id) {
        void this.manager.removeGraphic(id);
    }
    notifyPlayGraphic(id, params) {
        void this.manager.playGraphic(id, params);
    }
    notifyStopGraphic(id, params) {
        void this.manager.stopGraphic(id, params);
    }
    notifyUpdateGraphic(id, data) {
        void this.manager.updateGraphic(id, data);
    }
    notifyCustomAction(id, actionId, payload) {
        void this.manager.customAction(id, actionId, payload);
    }
}
